import { render, staticRenderFns } from "./AccidentPagination.vue?vue&type=template&id=782318af&"
import script from "./AccidentPagination.vue?vue&type=script&lang=js&"
export * from "./AccidentPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports